import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";
import ErrorImage from "../assets/images/error.png";
import Typography from "@material-ui/core/Typography";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  }
};

class ErrorSystem extends Component {
  backButton = () => {
    const {
      history: { push },
      auth = {}
    } = this.props;
    const { version = "v1" } = auth;
    if (version !== "v1") {
      push("/packages");
    } else {
      push("/home-old");
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Wrapper>
        <div style={{ margin: "16px", marginTop: "66px" }}>
          <div
            style={{
              marginTop: "32px",
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img
              alt="error_image"
              src={ErrorImage}
              style={{ width: "120px", height: "120px" }}
            />
          </div>
          <p
            style={{
              ...fontDefault,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "18px",
              color: "#0e162c"
            }}
          >
            ไม่สามารถสมัครประกันภัยได้
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: "center",
              fontSize: "16px",
              color: "#999999"
            }}
          >
            กรุณาติดต่อ บริษัท ทิพยประกันภัย จำกัด (มหาชน) โทร.1736
          </p>
          <br />

          <div
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <SubmitButton onClick={this.backButton} margin={true}>
              ตกลง
            </SubmitButton>
          </div>
        </div>
        <Header>
          <TopBar
            close={() => {
              window.location.replace("ascendmoney://closewebview");
            }}
          >
            <Typography align="center" className={classes.textTopBar}>
              ประกันภัยไวรัสโคโรนา
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ErrorSystem));
